export default {
  企业入驻中心提示1: '智能获客生态,释放企业无限潜能',
  企业入驻中心提示2: '您是否也遇到这些获客难题',
  企业入驻中心提示3: '打破企业销售瓶颈',
  企业入驻中心提示4: '渗透营销全场景,引领云端获客时代',
  企业入驻中心提示5: '打造获客、留存、转化、运营等数字营销闭环,一站式解决企业获客难题',
  企业入驻中心提示6: '云上专属权益,0障碍对接全球客户',
  企业入驻中心提示7: '搜索未来商机,抢占获客先机',
  企业入驻中心提示8: '100000+企业正在使用云展动力获客',
  企业入驻中心提示9: '简单四步',
  企业入驻中心提示10: '快速搭建云端营销体系,开启云上商机',
  立即体验: '立即体验',
  智能获客生态: '智能获客生态',
  立即试用: '立即试用',
  了解我们如何帮助企业获客: '了解我们如何帮助企业获客',

  运营成本高: '运营成本高？',
  落后商业模式: '落后商业模式？',
  难以获取精准商机: '难以获取精准商机？',
  获客渠道单一: '获客渠道单一？',
  数字贸易技术壁垒: '数字贸易技术壁垒？',
  员工工作效率低: '员工工作效率低？',
  销售管理混乱: '销售管理混乱？',
  获客难筛客难管客难: '获客难 筛客难 管客难？',
  线索流失率高: '线索流失率高？',
  优质客户资源有限: '优质客户资源有限？',
}
